import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { createUrl } from '@/util/url.ts'
import { MINUTE } from '@/constant/time.ts'

interface IResGetUsersDeviceStatus {}

export const apiGetUsersDeviceStatus = async ({}: IResGetUsersDeviceStatus = {}) => {
    return await apiGet<IUserDeviceStatus>(createUrl(`/protectee/summary/device-status`, {}))
}

const useQueryGetUsersDeviceStatus = (params?: IResGetUsersDeviceStatus) => {
    return useQuery({
        queryKey: QueryCacheKeys.user.getUsersDeviceStatus(),
        refetchInterval: 1 * MINUTE,
        queryFn: async () => {
            const { data } = await apiGetUsersDeviceStatus({ ...params })
            return data
        }
    })
}

export default useQueryGetUsersDeviceStatus

export interface IUserDeviceStatus {
    emergency: number
    online: number
    charging: number,
    offline: number
}
